var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marketing-page"},[_c('top-bar',{attrs:{"topbarList":_vm.marketingTopBarList}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }